import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=90d1ff2a&scoped=true"
import script from "./create-product.vue?vue&type=script&lang=ts"
export * from "./create-product.vue?vue&type=script&lang=ts"
import style0 from "./create-product.vue?vue&type=style&index=0&id=90d1ff2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d1ff2a",
  null
  
)

export default component.exports